import type { InfiniteScrollDirection } from 'logview/types';
import { INFINITE_SCROLL_DIRECTION_UP, INFINITE_SCROLL_DIRECTION_DOWN } from 'logview/Constants';

// eslint-disable-next-line import/prefer-default-export
export const isInfiniteScrollUp = (infiniteScrollDirection: InfiniteScrollDirection) =>
  infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_UP;
export const isInfiniteScrollDown = (infiniteScrollDirection: InfiniteScrollDirection) =>
  infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_DOWN;
